export const DOMAIN_CONTANTS = {
    platform: 'platform',
    syncflow: 'syncflow'
}